import type { ReactElement } from 'react';
import { Person as PersonIcon, Description as DescriptionIcon, AdminPanelSettings as AdminPanelSettingsIcon, Book as BookIcon, Policy as PolicyIcon, Payments as PaymentsIcon, Receipt as ReceiptIcon, RequestPage as RequestPageIcon } from '@mui/icons-material';
import { resources } from '@repo/c360-ra-components';

export type SectionLink = { label: string; to: string; resource: string };

export type SectionConfig = {
  title: string;
  description: string;
  icon: ReactElement;
  links: SectionLink[];
};

export const DASHBOARD_SECTIONS: SectionConfig[] = [
  {
    title: 'Users',
    description: 'Manage admin panel users and their access levels.',
    icon: <AdminPanelSettingsIcon sx={{ fontSize: 28 }} />,
    links: [{ label: 'Users', to: resources.adminUsers, resource: resources.adminUsers }],
  },
  {
    title: 'Client Users',
    description: 'C360 login records, MDM records, blacklist, sign-in/sign-up history, and manual merge records.',
    icon: <PersonIcon sx={{ fontSize: 28 }} />,
    links: [
      { label: 'C360 Login Records', to: resources.clientUsers, resource: resources.clientUsers },
      { label: 'Login Attempt History', to: resources.signinAttemptHistoryLogs, resource: resources.signinAttemptHistoryLogs },
      { label: 'MDM Records', to: resources.guardianCustomers, resource: resources.guardianCustomers },
      { label: 'Blacklist Records', to: resources.blacklistRecords, resource: resources.blacklistRecords },
      { label: 'Max Sign-up Records', to: resources.maxSignupRecords, resource: resources.maxSignupRecords },
      { label: 'Sign-up Attempt History', to: resources.signupAttemptHistoryLogs, resource: resources.signupAttemptHistoryLogs },
      { label: 'Manual Merge Records', to: resources.manualMerges, resource: resources.manualMerges },
    ],
  },
  {
    title: 'SalesPal Applications',
    description: 'SalesPal first-premium applications.',
    icon: <RequestPageIcon sx={{ fontSize: 28 }} />,
    links: [{ label: 'Applications', to: resources.salespalApplications, resource: resources.salespalApplications }],
  },
  {
    title: 'Payments & Renewals',
    description: 'Orders records, TA records, renewals, payment logs, FAC, and bank cards.',
    icon: <ReceiptIcon sx={{ fontSize: 28 }} />,
    links: [
      { label: 'Orders Records', to: resources.orderRecords, resource: resources.orderRecords },
      { label: 'Payment Logs', to: resources.manualPaymentExecutionLogs, resource: resources.manualPaymentExecutionLogs },
      { label: 'TA Records', to: resources.taReports, resource: resources.taReports },
      { label: 'FAC Records', to: resources.facRecords, resource: resources.facRecords },
      { label: 'Bank Cards', to: resources.bankCards, resource: resources.bankCards },
      { label: 'Non-Online Renewals', to: resources.nonOnlineRenewals, resource: resources.nonOnlineRenewals },
    ],
  },
  {
    title: 'Policies',
    description: 'System policies and configuration rules.',
    icon: <PolicyIcon sx={{ fontSize: 28 }} />,
    links: [{ label: 'Policies', to: resources.policies, resource: resources.policies }],
  },
  {
    title: 'Recurring Payments',
    description: 'Configured payments, cards, and execution history.',
    icon: <PaymentsIcon sx={{ fontSize: 28 }} />,
    links: [
      { label: 'Configured Payments', to: resources.recurringPayments, resource: resources.recurringPayments },
      { label: 'Configured Cards', to: resources.paymentCards, resource: resources.paymentCards },
      { label: 'Execution History', to: resources.recurringPaymentsExecutionLogs, resource: resources.recurringPaymentsExecutionLogs },
    ],
  },
  {
    title: 'Application Management',
    description: 'Applications, applicants, risk profiles, documents, DocuSign, and Onfido.',
    icon: <DescriptionIcon sx={{ fontSize: 28 }} />,
    links: [
      { label: 'Applications', to: resources.customerApplications, resource: resources.customerApplications },
      { label: 'Applicants', to: resources.applicants, resource: resources.applicants },
      { label: 'Risk Profiles', to: resources.riskProfiles, resource: resources.riskProfiles },
      { label: 'Documents', to: resources.documents, resource: resources.documents },
      { label: 'DocuSign', to: resources.docusign, resource: resources.docusign },
      { label: 'Onfido Verifications', to: resources.onfidoVerifications, resource: resources.onfidoVerifications },
    ],
  },
  {
    title: 'Support',
    description: 'Roles, audit logs, and knowledge base.',
    icon: <BookIcon sx={{ fontSize: 28 }} />,
    links: [
      { label: 'Roles and Permissions', to: resources.roles, resource: resources.roles },
      { label: 'Audit Logs', to: resources.auditLogs, resource: resources.auditLogs },
      { label: 'Knowledge Base', to: resources.troubleshootingGuidelines, resource: resources.troubleshootingGuidelines },
    ],
  },
];
